import type { FC, ReactNode } from 'react';
import { Children } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { clsx } from 'clsx';

interface DroppableColumnProps {
  id: string;
  title: string;
  children: ReactNode;
}

export const DroppableColumn: FC<DroppableColumnProps> = ({ id, title, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: {
      type: 'column',
      accepts: ['ActionItem'], // Especifica que aceita itens de ação
    },
  });
  

  const isEmpty = !children || (Array.isArray(children) && children.length === 0) || Children.count(children) === 0;

  return (
    <div 
      ref={setNodeRef} 
      id={id} 
      className={clsx(
        "bg-gray-100 p-4 rounded-lg transition-all duration-300 ease-in-out h-fit",
        isOver ? "bg-blue-100 border-blue-400 border-2 border-dashed scale-102 shadow-lg" : "border-transparent border-2"
      )}
    >
      <h3 className="font-bold text-lg text-gray-800 mb-4 text-center">{title}</h3>
      <div className="space-y-3 min-h-[200px] relative">
        {children}
        {isEmpty && (
          <div className={clsx(
            "absolute inset-0 flex items-center justify-center text-sm transition-all duration-200",
            isOver ? "text-blue-600 font-medium" : "text-gray-400"
          )}>
            {isOver ? "✨ Solte o card aqui" : "Solte os cards aqui"}
          </div>
        )}
      </div>
    </div>
  );
}; 